import { useState } from 'react';
import { InputTypes, FAIcon } from '@nextgen-web-framework/all';
import { QtyStepperProps } from './types/propsType';
import { MAX_COUNT, MIN_COUNT } from './types/enums';
import styles from './QtyStepper.module.scss';

export const QtyStepper = ({
  miniusButtonDisabled,
  plusButtonDisabled,
  onQuantityChange = () => null,
  overrideClassName = '',
  disableQtyStepper = false,
  initialCount = 0,
  disableApiCallOnQtyUpdate = false,
  enableHoverEffect = true,
}: QtyStepperProps) => {
  const [count, setCount] = useState(initialCount);
  const [active, setActive] = useState(false);

  const disablePlusIcon = count === MAX_COUNT;
  const disableMinusIcon = count === MIN_COUNT;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.validity.valid) {
      return;
    }
    setCount(+e.target.value);
    if (!disableApiCallOnQtyUpdate) {
      onQuantityChange(+e.target.value);
    }
  }

  function handleBlur(e: React.FocusEvent<HTMLInputElement, Element>) {
    if (+e.target.value == 0) {
      setCount(1);
    }
    setActive(false);
  }

  const increaseCount = () => {
    if (disableQtyStepper) {
      return;
    }
    if (!plusButtonDisabled && count !== MAX_COUNT) {
      setCount((num) => {
        if (!disableApiCallOnQtyUpdate) {
          onQuantityChange(num + 1);
        }
        return num + 1;
      });
    }
  };
  const decreaseCount = () => {
    if (disableQtyStepper) {
      return;
    }
    if (count !== MIN_COUNT && !miniusButtonDisabled) {
      setCount((num) => {
        if (!disableApiCallOnQtyUpdate) {
          onQuantityChange(num - 1);
        }
        return num - 1;
      });
    }
  };

  return (
    <div
      className={`${styles['add-to-cart-stepper-component']} 
     ${overrideClassName}`}
    >
      <div
        className={`${styles['add-to-cart-stepper-container']} 
        ${enableHoverEffect && styles['add-to-cart-stepper-hover-effect-disabled']}
        ${enableHoverEffect && styles['add-to-cart-stepper-hover-effect']}
        ${disableQtyStepper && styles['add-to-cart-stepper-container-disabled']}`}
      >
        {!active && (
          <span
            role="button"
            tabIndex={0}
            data-testid="test-minus-button"
            onClick={decreaseCount}
            onKeyDown={decreaseCount}
            className={`${styles['add-to-cart-stepper-container-icon']} ${styles['add-to-cart-stepper-container-icon-minus']}`}
            aria-label="minus"
          >
            <FAIcon
              className={`${(miniusButtonDisabled || disableMinusIcon) && styles['disable-icon']} ${
                styles['add-to-cart-stepper-container-icon-fa']
              }`}
              iconName="minus"
            />
          </span>
        )}
        <input
          disabled={disableQtyStepper}
          min={1}
          readOnly={plusButtonDisabled || miniusButtonDisabled ? true : false}
          maxLength={3}
          name="inputQty"
          type={InputTypes.TEXT}
          pattern="[1-9]?[0-9]{1,2}"
          onChange={handleChange}
          className={styles['add-to-cart-stepper-container-count']}
          value={count}
          onClick={() => setActive(!(miniusButtonDisabled || plusButtonDisabled) as boolean)}
          onBlur={handleBlur}
        />
        {!active && (
          <span
            role="button"
            tabIndex={0}
            onKeyDown={increaseCount}
            data-testid="test-plus-button"
            onClick={increaseCount}
            className={`${styles['add-to-cart-stepper-container-icon']} ${styles['add-to-cart-stepper-container-icon-plus']}`}
            aria-label="plus"
          >
            <FAIcon
              className={`${(plusButtonDisabled || disablePlusIcon) && styles['disable-icon']} ${
                styles['add-to-cart-stepper-container-icon-fa']
              }`}
              iconName="plus"
            />
          </span>
        )}
      </div>
    </div>
  );
};
